import React, { useState } from 'react';
import { ONBOARDING_VOUCHER_ACTIVATION_TITLE } from '../../constants/Copy';
import Heading, { HEADING_SIZE } from '../common/heading/Heading';
import Voucher from './Voucher';
import { useVoucherCheck } from './useVoucherCheck';
import useSearchParams from '../../hooks/useSearchParams';
import { PARAM_NAMES } from '../../constants/Checkout';

const { VOUCHERCODE } = PARAM_NAMES;

export default function VoucherContainer() {
	const { getSearchParam } = useSearchParams();
	const voucherCodeQueryParam = getSearchParam(VOUCHERCODE);
	const [voucher, setVoucher] = useState(voucherCodeQueryParam ? voucherCodeQueryParam : '');
	const voucherCheckProps = useVoucherCheck(voucher, null, voucherCodeQueryParam);

	return (
		<>
			<Heading size={HEADING_SIZE.MEDIUM}>{ONBOARDING_VOUCHER_ACTIVATION_TITLE}</Heading>
			<Voucher
				voucher={voucher}
				setVoucher={setVoucher}
				isFormOpen
				voucherCheckProps={voucherCheckProps}
			/>
		</>
	);
}
